(function () {
  const STORAGE_KEY = 'recently_viewed_products';
  const MAX_ITEMS = 20;

  if (!window.Shopify || !Shopify.routes || !Shopify.routes.root) return;
  if (!window.meta || !meta.product) return;

  const currentProduct = {
    id: meta.product.id,
    handle: meta.product.handle
  };

  let items = [];

  try {
    items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (e) {
    items = [];
  }

  // Remove duplicate
  items = items.filter(item => item.id !== currentProduct.id);

  // Add to top
  items.unshift(currentProduct);

  // Limit items
  items = items.slice(0, MAX_ITEMS);

  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
})();
